
import {AMWAY_PAY_METHODS, NORMAL_PAYMENT_METHODS, PAYMENT_METHODS} from "@/utils/constants";

// paymentMode: "apayaccount",
// paymentCode: "bWzn16mywdYPBal2vxj81j6b2mzR1RK35RQgOAND7pJe9KE0q",

// paymentMode: "apaycreditcard",
// paymentCode: "cWkABYDxNyJQbgMGZzorzjR0bxmx12Krl5E1em4dKva7XL9nj",

export default {
  namespaced: true,
  state: {
    paymentMode: "",
    paymentCode: "",
    customerId: "",
    issuerCode: "",
    issuerName: "",
    installmentPlan: "",
    receiptType: "",
    receiptIssuanceType: "",
    receiptNumberType: "",
    receiptIssuanceNumber: "",
    receivePhone: "",
    deliveryAddress: "",
    deliveryMessage: "",
  },
  mutations: {
    reset(state) {
      state.paymentMode = ""
      state.paymentCode = "";
      state.customerId = "";
      state.issuerCode = "";
      state.issuerName = "";
      state.installmentPlan = "";
      state.receiptType = "";
      state.receiptIssuanceType = "";
      state.receiptNumberType = "";
      state.receiptIssuanceNumber = "";
      state.receivePhone = "";
      state.deliveryAddress = "";
      state.deliveryMessage = "";
    },
    setPaymentInfo(state, value) {
      state.paymentMode = value.paymentMode || "";
      state.paymentCode = value.paymentCode || "";
      state.customerId = value.customerId || "";
      state.issuerCode = value.issuerCode || "";
      state.issuerName = value.issuerName || "";
      state.installmentPlan = value.installmentPlan || "0";;
      state.receiptType = value.receiptType;
      state.receiptIssuanceType = value.receiptIssuanceType;
      state.receiptNumberType = value.receiptNumberType;
      state.receiptIssuanceNumber = value.receiptIssuanceNumber;
      state.receivePhone = value.receivePhone;
      state.deliveryAddress = value.deliveryAddress;
      state.deliveryMessage = value.deliveryMessage;
    },
    setPaymentMode(state, value) {
      state.paymentMode = value;
    },
  },
  actions: {
    reset({ commit }) {
      commit('reset');
    },
    setPaymentInfo({ commit }, payload) {
      commit('setPaymentInfo', payload);
    },
    setPaymentMode({ commit }, payload) {
      commit('setPaymentMode', payload);
    },
  },
  getters: {
    deliveryAddressInfo(state) {
      return {
        deliveryAddress: state.deliveryAddress,
        deliveryMessage: state.deliveryMessage,
      }
    },
    receivePhoneInfo(state) {
      return state.receivePhone;
    },
    receiptInfo(state) {
      return {
        receiptType: state.receiptType,
        receiptIssuanceType: state.receiptIssuanceType,
        receiptNumberType: state.receiptNumberType,
        receiptIssuanceNumber: state.receiptIssuanceNumber,
      }
    },
    paymentInfo(state) {
      return {
        paymentMode: state.paymentMode,
        paymentCode: state.paymentCode,
        customerId: state.customerId,
        issuerCode: state.issuerCode,
        issuerName: state.issuerName,
        installmentPlan: state.installmentPlan,
      }
    },
    currentPaymentMethod(state) {
      let paymentMethod;
      switch (state.paymentMode) {
        case "quickaccount":
          paymentMethod = PAYMENT_METHODS.AMWAY_PAY;
          break;
        case "apayaccount":
          paymentMethod = PAYMENT_METHODS.AMWAY_PAY;
          break;
        case "apaycreditcard":
          paymentMethod = PAYMENT_METHODS.AMWAY_PAY;
          break;
        case "transfer":
          paymentMethod = PAYMENT_METHODS.NORMAL;
          break;
        case "creditcard":
          paymentMethod = PAYMENT_METHODS.NORMAL;
          break;
        default:
          paymentMethod = null;
      }
      return paymentMethod;
    },
    currentAmwayPayMethod(state) {
      let amwayPayMethod;
      switch (state.paymentMode) {
        case "quickaccount":
          amwayPayMethod = AMWAY_PAY_METHODS.QUICK_ACCOUNT;
          break;
        case "apayaccount":
          amwayPayMethod = AMWAY_PAY_METHODS.ACCOUNT;
          break;
        case "apaycreditcard":
          amwayPayMethod = AMWAY_PAY_METHODS.CARD;
          break;
        default:
          amwayPayMethod = null
      }
      return amwayPayMethod;
    },
    currentOtherPayMethod(state) {
      let otherPayMethod;
      switch (state.paymentMode) {
        case "transfer":
          otherPayMethod = NORMAL_PAYMENT_METHODS.TRANSFER;
          break;
        case "creditcard":
          otherPayMethod = NORMAL_PAYMENT_METHODS.CREDIT_CARD;
          break;
        default:
          otherPayMethod = null
      }
      return otherPayMethod;
    }
  }
}